import React, { FC, useId } from 'react';
import { createPortal } from 'react-dom';
import './DropdownMenuTable.scss';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH, faEllipsisV } from '@fortawesome/free-solid-svg-icons';

interface DropdownMenuTableProps extends React.HTMLAttributes<HTMLDivElement> {
  orientationIcon?: string;
}

const DropdownMenuTable: FC<DropdownMenuTableProps> = ({ children, orientationIcon = 'horizontal' }) => {
  const id = useId();
  return (
    <Dropdown className="DropdownMenuTable" align="end" data-testid="DropdownMenuTable">
      <Dropdown.Toggle id={`dropdownTable${id}`} className="cursor-pointer option" as="div">
        {orientationIcon === 'vertical' ? (
          <FontAwesomeIcon icon={faEllipsisV} />
        ) : (
          <FontAwesomeIcon icon={faEllipsisH} />
        )}
      </Dropdown.Toggle>
      {createPortal(
        <Dropdown.Menu
          className="DropdownMenuTable-menu"
          aria-labelledby={`dropdownTable${id}`}
          popperConfig={{ strategy: 'fixed' }}
        >
          <div className="DropdownMenuTable-menu-inner py-2">
            {children}
          </div>
        </Dropdown.Menu>,
        document.body
      )}
    </Dropdown>
  );
}

export default DropdownMenuTable;
